// extracted by mini-css-extract-plugin
module.exports = {"container":"x_m","loaderInit":"x_bc","iconWrapper":"x_bd","icon":"x_k","loader":"x_bf"};